import { memo } from 'react';

import classnames from 'clsx';
import { TabList as ReactTabsTabList } from 'react-tabs';

import style from './tab-list.module.css';

import type { TabListProps } from 'react-tabs';
import type { ReactTabsMemoComponent } from 'ui-components/components/tabs/tabs-types';

export const TabList: ReactTabsMemoComponent<TabListProps> = memo(({ className, children, ...rest }) => (
  <ReactTabsTabList className={classnames(style['tab-list'], className)} {...rest}>
    {children}
  </ReactTabsTabList>
));

TabList.displayName = 'TabList';
TabList.tabsRole = 'TabList';
